<div>
    <div class="container">
        <span class="gap"></span>

        <div class="header">
            <h1>Photo Gallery</h1>
            <p class="subtitle">Explore photos from our events and exhibitions</p>
        </div>

        <div class="filter-bar" *ngIf="!eventSlug">
            <label for="eventFilter">Filter by Event:</label>
            <select id="eventFilter" [(ngModel)]="selectedEvent" (change)="filterByEvent(selectedEvent)"
                class="event-select">
                <option value="all">All Events</option>
                <option *ngFor="let event of events" [value]="event.fields.url">{{event.fields.title}}</option>
            </select>
        </div>

        <div *ngIf="loading" class="loading">
            <p>Loading gallery...</p>
        </div>

        <div *ngIf="!loading && filteredImages.length === 0" class="no-images">
            <p>No photos available yet. Check back soon!</p>
        </div>

        <div class="gallery-grid" *ngIf="!loading && filteredImages.length > 0">
            <div *ngFor="let image of filteredImages" class="gallery-item" (click)="openLightbox(image)">
                <img [src]="image.fields.image.fields.file.url + '?w=600&h=600&fit=fill'" [alt]="image.fields.title"
                    loading="lazy">
                <div class="gallery-overlay">
                    <div class="gallery-info">
                        <h3>{{image.fields.title}}</h3>
                        <p *ngIf="image.fields.date">{{image.fields.date | date:'MMM d, yyyy'}}</p>
                    </div>
                </div>
            </div>
        </div>

        <span class="gap"></span>
    </div>

    <!-- Lightbox Modal -->
    <div class="lightbox" *ngIf="selectedImage" (click)="closeLightbox()">
        <div class="lightbox-content" (click)="$event.stopPropagation()">
            <button class="close-btn" (click)="closeLightbox()" aria-label="Close image viewer">
                <mat-icon>close</mat-icon>
            </button>

            <button class="nav-btn prev-btn" (click)="previousImage()"
                *ngIf="filteredImages.indexOf(selectedImage) > 0" aria-label="Previous image">
                <mat-icon>chevron_left</mat-icon>
            </button>

            <div class="lightbox-image-container">
                <img [src]="selectedImage.fields.image.fields.file.url" [alt]="selectedImage.fields.title">
                <div class="lightbox-info">
                    <h2>{{selectedImage.fields.title}}</h2>
                    <p *ngIf="selectedImage.fields.date">{{selectedImage.fields.date | date:'MMMM d, yyyy'}}</p>
                    <p *ngIf="selectedImage.fields.event" class="event-tag">{{selectedImage.fields.event.fields.title}}
                    </p>
                    <p *ngIf="selectedImage.fields.photographer" class="photographer">Photo by
                        {{selectedImage.fields.photographer}}</p>
                </div>
            </div>

            <button class="nav-btn next-btn" (click)="nextImage()"
                *ngIf="filteredImages.indexOf(selectedImage) < filteredImages.length - 1" aria-label="Next image">
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>
    </div>
</div>